// @flow

import type { BuildPlatformAlias } from '../types/flow/BuildPlatformAlias';

export default ([
  'all',
  'node',
  'web',
  'webApple',
  'webAppleIos',
  'webAppleMacos',
]: BuildPlatformAlias[]);
